export default __webpack_public_path__ + "static/media/car-unauthorized.6021f02a.svg";